import { useEffect } from "react";

export function usePageMeta(title, description) {
  useEffect(() => {
    const full = title ? `${title} · Lord Almighty` : "Lord Almighty";
    document.title = full;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [title, description]);
}
